<template>
  <template v-if="mode === 'edit'">
    <div
      :class="[
        'py-2 state-field',
        field.error
          ? 'my-2 px-2 rounded border-2 border-brand-red bg-brand-red bg-opacity-10'
          : ''
      ]"
      :name="field.name"
      :field-id="field.field_id"
      :required="field.required"
    >
      <div class="pb-2">
        <label v-if="field.label" for="input" class="block mb-3">
          {{ field.label }}
          <span v-if="field.required" class="text-brand-red">*</span>
        </label>
        <DropDown
          :options="states"
          placeholder="State"
          :initial="initialState"
          @select="updateValue"
        ></DropDown>
      </div>
      <template v-if="field.help_text">
        <p class="text-brand-mid-gray italic text-xs">{{ field.help_text }}</p>
      </template>
      <template v-if="field.error">
        <p class="text-brand-red py-1">{{ errorMessage }}</p>
      </template>
    </div>
  </template>
  <template v-if="mode === 'view'"> </template>
  <template v-if="mode === 'form_edit'">
    <div class="flex flex-col w-full">
      <div class="w-full py-1">
        <DropDown :disabled="true" :options="states" placeholder="State" />
      </div>
      <TextDisplayEditToggle
        :helpText="field.help_text"
        :type="'field_subtext'"
        @input="updateHelpText"
        :disabled="field.editable === false"
      />
    </div>
  </template>
</template>
<script>
const states = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "PR", label: "Puerto Rico" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" }
]

export default {
  props: {
    field: Object,
    mode: {
      type: String
    },
    stage: {
      type: String
    }
  },
  emits: ["update"],
  computed: {
    isValid() {
      if (this.field.required && !this.field.value) return false

      return true
    }
  },
  data() {
    return {
      states,
      initialState: null,
      errorMessage: ""
    }
  },
  mounted() {
    // If editing field value, map the dropdowns and year input
    if (this.field.value) {
      this.initialState = this.states.find(
        (el) => el.value === this.field.value
      )
    }
  },
  methods: {
    updateHelpText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.help_text = ev.target.value
    },
    updateValue(val) {
      this.$emit("update", val.value)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = "This field is required."
        }
      } else {
        this.errorMessage = ""
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
